module.exports = __webpack_public_path__ + "static/media/pantheon.acc6d15e.png";